import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-medium tracking-tight font-serif hover:text-accent transition-colors">
            Decided
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm">
              Log in
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <h1 className="text-3xl md:text-4xl font-medium tracking-tight font-serif text-foreground">
          Privacy Policy
        </h1>

        <div className="mt-12 space-y-6 text-muted-foreground leading-relaxed">
          <p className="text-foreground text-lg">
            Decided respects your privacy.
          </p>

          <p>
            Decided collects only the data required to operate the service:
          </p>

          <ul className="space-y-2 text-foreground">
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>your account email address</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>the decisions and follow-ups you create</span>
            </li>
          </ul>

          <p>
            Your data is private and is not sold or shared with third parties.
          </p>

          <p>
            Email addresses are used only for:
          </p>

          <ul className="space-y-2 text-foreground">
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>account access</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>reminder emails</span>
            </li>
          </ul>

          <p>
            All data is stored securely.
          </p>

          <p>
            You may request deletion of your account and associated data at any time.
          </p>

          <p>
            If you have questions about privacy, please contact us at <a href="mailto:hello@usedecided.com" className="text-foreground underline underline-offset-4 hover:text-accent transition-colors">hello@usedecided.com</a>.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/why" className="hover:text-foreground transition-colors">Why Decided</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            <Link to="/login" className="hover:text-foreground transition-colors">Login</Link>
          </div>
          <p className="mt-6 text-center text-xs text-muted-foreground/50">
            © {new Date().getFullYear()} Decided
          </p>
        </div>
      </footer>
    </div>
  );
}
